export enum FormFieldTypeEnum {
  TEXT = 'text',
  NUMBER = 'number',
  INTEGER = 'integer',
  BOOLEAN = 'boolean',
  SELECT = 'select',
  TEXTAREA = 'textarea',
  DATE = 'date',
  TIMESTAMP = 'timestamp',
}
